import IOS from "./Mobile/IOS"

export default (props) => {
    return <IOS {...props}/>
}